// extracted by mini-css-extract-plugin
export var badge = "Card-module--badge--bWfUL";
export var component = "Card-module--component--Dz9qP";
export var content = "Card-module--content--ccrWf";
export var dummy = "Card-module--dummy--b6w4-";
export var inner = "Card-module--inner--LbUr5";
export var media = "Card-module--media--4Trqj";
export var meta = "Card-module--meta--fJqG1";
export var title = "Card-module--title--Zhogg";